module.exports = __webpack_public_path__ + "img/album11_03.30346bca.jpg";